import React from 'react';

import { PAYMENT_METHODS } from '../Instapay';
import instapayIcon from './../../../../../../statics/img/instapay/instapay_icon_2.png';

function IntentMethod({ onPay }) {
  return (
    <div className='instapay_intent'>
      <button onClick={() => onPay(PAYMENT_METHODS.INTENT)}>
        <img src={instapayIcon} alt="instapay" />
      </button>
    </div>
  );
}

export default IntentMethod;
